import React from "react";
import propTypes from "prop-types";
import classnames from "classnames";

import "./PanelGrid.scss";
import { createDataAttributes } from "../../utilities";

const PanelGrid = ({
  children,
  className,
  sizes,
  rowHeight,
  dataAttrib,
  ...rest
}) => {
  const defaultSizes = { sm: 2, md: 3, lg: 3, xl: 4 };

  const s = {
    ...defaultSizes,
    ...sizes
  };

  const classes = classnames(
    "uikit__panelgrid",
    className,
    `uikit__panelgrid__sm${s.sm}`,
    `uikit__panelgrid__md${s.md}`,
    `uikit__panelgrid__lg${s.lg}`,
    `uikit__panelgrid__xl${s.xl}`
  );

  const styl = {};
  if (rowHeight) styl.gridAutoRows = `minmax(${rowHeight}px, auto)`;

  return (
    <div
      className={classes}
      {...createDataAttributes(dataAttrib)}
      {...rest}
      style={styl}
    >
      {children}
    </div>
  );
};

PanelGrid.propTypes = {
  children: propTypes.oneOfType([
    propTypes.arrayOf(propTypes.node),
    propTypes.node,
    propTypes.element
  ]).isRequired,
  className: propTypes.string,
  sizes: propTypes.shape({
    sm: propTypes.number,
    md: propTypes.number,
    lg: propTypes.number,
    xl: propTypes.number
  }),
  rowHeight: propTypes.number,
  rowFixedHeight: propTypes.bool,
  dataAttrib: propTypes.arrayOf(Object)
};

export default PanelGrid;
